import { InfraredJob } from "@nova/protobuf"
import { entityValidator, enumValidator, extraFeaturesValidator, UnionToTuple } from "../util"
import { JobStatusType, InfraredProcessingMode } from "@nova/constants"
import { dateAsNumber } from "../../util"

export const createInfraredJobValidator = entityValidator(InfraredJob, {
    processingMode: {
        validators: enumValidator("processingMode", InfraredProcessingMode),
        nonNull: true,
    },
})

export const updateInfraredJobValidator = entityValidator(InfraredJob, {
    extraFeatures: {
        validators: extraFeaturesValidator,
    },
    status: {
        validators: enumValidator("status", JobStatusType),
        nonNull: true,
    },
    maxZoom: {
        validators: [
            {
                validator: (maxZoom) => maxZoom > 0 && maxZoom < 26,
                error: "Max zoom is out of range",
            },
        ],
        nonNull: true,
    },
})

export const getDefaultInfraredJobCreateArgs = () => ({
    createdAt: dateAsNumber(),
    status: JobStatusType.QUEUED,
    scanArea: [],
})

export type CreateInfraredJobArgs = UnionToTuple<keyof typeof createInfraredJobValidator>
export type UpdateInfraredJobArgs = UnionToTuple<keyof typeof updateInfraredJobValidator>
